// import Vue from 'vue'

export default {
    name : 'courses',
    init() {
        const elements = document.querySelectorAll('.js_course-card.hide-on-init');
        const button = document.querySelector('.js_showHiddenItems');

        if (elements.length === 0) {
            if (button) {
                button.remove();
            }
            return false;
        }

        elements.forEach((el) => el.classList.add('hidden'));
        if (button) {
            button.addEventListener('click', () => {
                elements.forEach((el) => el.classList.remove('hidden'));
                button.remove();
            });
        }
    }
}